module.exports = __webpack_public_path__ + "img/fempa_white_logo.eb5ddc4d.png";